export default __webpack_public_path__ + "static/ux-report-3d8254a397b23f4fa634ad6d64f6e0fa.png";